var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.ctaPremission)?_c('not-found'):_c('div',[_c('HeaderSteps',{attrs:{"title":`Edit ${_vm.flight?.name}`,"back-path":-1}}),(_vm.currentStep === 0)?[_c('CampaignPeriod',{attrs:{"loading":_vm.loading},on:{"step":_vm.getCurrentStep}})]:_vm._e(),(_vm.currentStep === 1)?[_c('Assets')]:_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }